export default __webpack_public_path__ + "static/media/discord_logo.bedd19ca.svg";